import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Loader, SpeedometerProgress, TotalCard, WrapperCard } from 'components/elements';
import { useTranslation, useTranslationX } from 'i18n';
import { useFetch } from 'apis';
import { CounterpartState } from '../Dashboard/types';
import { getMasked } from 'utils/inputMask';
import { convertHexColorToRGBA } from 'utils/stringUtils';

import styles from './CounterpartCard.module.scss';
import { useFirstRender } from 'components/hooks';

type CounterpartEvolution = {
  comprovados: number;
  valorTotal: number;
  duracao: number;
  inicioRelativo: string;
  porcentagem: number;
  porcentagemPrevisto: number;
  total: number;
};

const CounterPartCardGroup = ({ state }: { state: CounterpartState }) => {
  const { tx } = useTranslationX('contrapartida', 'project');
  const { t } = useTranslation();

  const location = useLocation();

  const firstRender = useFirstRender();
  const pathnames = location.pathname.split('/');
  const projectId = pathnames[pathnames.length - 2];
  const { data, reload } = useFetch<CounterpartEvolution>(
    `projeto/${projectId}/contrapartidas/evolucao`
  );

  useEffect(() => {
    if (firstRender || !state.lastUpdate) return;
    reload();
  }, [state.lastUpdate, reload, firstRender]);

  if (!data) {
    return <Loader />;
  }

  const { porcentagem, total, porcentagemPrevisto, comprovados, valorTotal } = data;

  return (
    <div className={styles.counterpartCard}>
      <h1 className={styles.header}>{tx('title')}</h1>
      <TotalCard value={total} label={tx('totalValue')} />
      <div className={styles.graphsArea}>
        <WrapperCard padding="21px" maxWidth="600px">
          <div className={styles.graph}>
            <SpeedometerProgress
              value={porcentagem}
              colorGradient={['#e1bfff', '#c98cff']}
              radius={140}
            />

            <span>{tx('proven')}</span>
            <p>{tx('rhComprovedValue')}</p>
            <p>
              <strong>
                {`${t('currency')} ${getMasked(comprovados.toFixed(2), {
                  pattern: 'currency',
                })}`}
              </strong>
            </p>
          </div>
        </WrapperCard>
        <WrapperCard padding="21px" maxWidth="600px">
          <div className={styles.graph}>
            <SpeedometerProgress
              value={porcentagemPrevisto}
              colorGradient={[convertHexColorToRGBA('#3FC75C', 0.65), '#3FC75C']}
              radius={140}
            />

            <span>{tx('previsto')}</span>
            <p>{tx('rhPrevistoValue')}</p>
            <p>
              <strong>
                {`${t('currency')} ${getMasked(valorTotal.toFixed(2), {
                  pattern: 'currency',
                })}`}
              </strong>
            </p>
          </div>
        </WrapperCard>
      </div>
    </div>
  );
};

export default CounterPartCardGroup;
